export const CORDATA = {
  REQUEST: 'StatementOfRequirements/GetCor/Request',
  SUCCESS: 'StatementOfRequirements/GetCor/Success',
  FAILURE: 'StatementOfRequirements/GetCor/Failure'
};
export const UPDATE = {
  REQUEST: 'StatementOfRequirements/UpdateCor/Request',
  SUCCESS: 'StatementOfRequirements/UpdateCor/Success',
  FAILURE: 'StatementOfRequirements/UpdateCor/Failure'
};
export const CLEAR = {
  SUCCESS: 'StatementOfRequirements/ClearCor/Success',
  FAILURE: 'StatementOfRequirements/ClearCor/Failure'
};
export const EXPORTCOR = {
  REQUEST: 'StatementOfRequirements/ExportCor/Request',
  SUCCESS: 'StatementOfRequirements/ExportCor/Success',
  FAILURE: 'StatementOfRequirements/ExportCor/Failure'
};
